<div class="page-not-found-container">
  <p class="text-xl font-bold">ไม่พบหน้าที่ต้องการ</p>
</div>
